function sortDates(a, b) {
  function createDateObj(dateStr) {
    if (typeof dateStr === 'string') {
      const separators = ['\\.', '\\-', '\\/'];
      const dateArr = dateStr.split(new RegExp(separators.join('|'), 'g'));
      if (dateStr.indexOf('-') > -1) {
        dateArr.reverse();
      }
      const dateObj = new Date(
        dateArr[2],
        parseInt(dateArr[1], 10) - 1,
        dateArr[0],
      );
      return dateObj;
    }
    return undefined;
  }
  if (a === '' || b === '') {
    return 0;
  }
  const dateA = createDateObj(a);
  const dateB = createDateObj(b);
  const timeA = dateA.getTime();
  const timeB = dateB.getTime();
  if (timeA < timeB) {
    return -1;
  }
  if (timeA > timeB) {
    return 1;
  }
  return 0;
}

export default function SortFixtures(fixtureData, viewSettings) {
  if (!fixtureData.length) {
    return [];
  }

  const fixtureDataCopy = fixtureData.filter((item) => {
    return (
      item.opponent
        .toLowerCase()
        .indexOf(viewSettings?.searchOpponent?.toLowerCase()) !== -1
    );
  });

  if (viewSettings.sortBy.column === 'matchDate') {
    fixtureDataCopy.sort((a, b) => {
      const dateA = a.matchDate;
      const dateB = b.matchDate;
      return sortDates(dateA, dateB);
    });
  }

  if (viewSettings.sortBy.column === 'opponentName') {
    fixtureDataCopy.sort((a, b) => {
      const nameA = a.opponent.toLowerCase();
      const nameB = b.opponent.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }

  if (viewSettings.sortBy.column === 'basePackage') {
    fixtureDataCopy.sort((a, b) => {
      const dateA = a.base.from;
      const dateB = b.base.from;
      return sortDates(dateA, dateB);
    });
  }
  if (viewSettings.sortBy.column === 'fullPackage') {
    fixtureDataCopy.sort((a, b) => {
      const dateA = a.full.from;
      const dateB = b.full.from;
      return sortDates(dateA, dateB);
    });
  }

  if (viewSettings.sortBy.order === 'desc') {
    fixtureDataCopy.reverse();
  }

  return fixtureDataCopy;
}
